const OrderAddress = ({ shippingAddress }) => {
  const {
    street,
    number,
    complement,
    neighborhood,
    reference,
    city,
    state,
    zipCode,
  } = shippingAddress;

  return (
    <div className="col-12 col-md-6 col-xl-4 d-flex align-items-start gap-3 mt-4">
      <i className="fas fa-map-marker-alt text-muted mt-1" />
      <div>
        <p className="text-muted fw-bold mb-2">ENDEREÇO DE ENTREGA</p>
        <div className="lh-base">
          <span className="mb-0">
            <span className="fw-bold">Endereço: </span>
            {street || ''}
          </span>
          <br />
          <span className="mb-0">
            <span className="fw-bold">Número: </span>
            {number || ''}
          </span>
          <br />
          <span className="mb-0">
            <span className="fw-bold">Complemento: </span>
            {complement || ''}
          </span>
          <p className="mb-0">
            <span className="mb-0">
              <span className="fw-bold">Bairro: </span>
              {neighborhood || ''}
            </span>
            <br />
            <span className="mb-0">
              <span className="fw-bold">Referência: </span>
              {reference || ''}
            </span>
          </p>
          <p className="mb-0">
            <span className="fw-bold">Cidade:</span> {city || ''}
          </p>
          <p className="mb-0">
            <span className="fw-bold">Estado:</span> {state || ''}
          </p>
          <p className="mb-0">
            <span className="fw-bold">CEP:</span> {zipCode || ''}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OrderAddress;
